// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HelpIcon_helpIcon__77nA- {
    color: var(--color-icon-primary);
    display: inline-flex;
    vertical-align: middle;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/HelpIcon/HelpIcon.module.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;AACnB","sourcesContent":[".helpIcon {\n    color: var(--color-icon-primary);\n    display: inline-flex;\n    vertical-align: middle;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpIcon": `HelpIcon_helpIcon__77nA-`
};
export default ___CSS_LOADER_EXPORT___;
